type Props = {
  height: string;
  stroke: string;
  width: string;
};

const ChevronIcon = ({ stroke, width, height }: Props) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 10 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8.99951 1L4.99951 5L0.999512 1" stroke={stroke} />
      </svg>
    </>
  );
};

export default ChevronIcon;
